<template>
    <div class="m-recommend">
        <ul v-if="list.length">
            <li v-for="(item,index) in list" :key="index">
                <div class="goods-panel">
                    <div class="goods-detail">
                        <div class="goods-status">
                            <div class="tag tag-sale" v-if="item.discountType"></div>
                            <div class="tag tag-shop" v-if="item.shopOfferType"></div>
                        </div>
                        <div class="banner" @click="see_offer(item.shopId);">{{ item.shopName }}<em class="shop-guide">></em></div>
                        <div class="discount">{{ item.discountName }}</div>

                        <div class="item-detail clearfix">
                            <div class="pic f-l" 
                            v-if="$store.state.tipsimg.indexOf(item.itemid) > -1" 
                            @click="$item_tips({ item_id : item.itemid + '.png',type : 'img'})">
                            <div class="item-pic"><game-item :id="item.itemid" :num="item.itemcount" :locked="true"></game-item></div>
                            </div>
                            <div class="pic f-l" v-else 
                            @click="$item_tips({ item_id : item.itemid})"><div class="item-pic"><game-item :id="item.itemid" :num="item.itemcount" :locked="true"></game-item></div></div>
                            <div class="item-info f-l">
                                <h6 class="item-name">{{ item.name }}</h6>
                                <div class="low">最低价<em class="icon-m3b"></em><span>{{ item.priceMin }}</span><span class="p-before">{{ item.priceBefore }}</span></div>
                            </div>
                            <div class="u-btn apply f-l" v-bind:data-gid="item.id" @click="discountStart(item.id)"></div>                         
                        </div>                       
                    </div>
                </div>

                
            </li>
        </ul>
    </div>    
</template>

<script>
export default {
    data () {
        return {
            list : [],
        }
    },
    created (){
        //this.list = this.$get_goodslist().slice(0,2)
        this.list = this.getRandomArrayElements(this.$get_goodslist(), 2);
    },
    methods : {
        getRandomArrayElements(arr, count){
            if(arr.length < count)return [];

            var shuffled = arr.slice(0), i = arr.length, min = i - count, temp, index;
            while (i-- > min) {
            index = Math.floor((i + 1) * Math.random());
            temp = shuffled[index];
            shuffled[index] = shuffled[i];
            shuffled[i] = temp;
            }
            return shuffled.slice(min);      
        },
        discountStart (gid){
            //TODO
            this.$share_modal({
                gid : gid,
            })
        },
        see_offer (sid){
            this.$router.push({ name: 'offer', params: { sid: sid }});
        }         
    },
}
</script>

<style scoped>
/* rec */
.m-recommend {
    width: 750px;
    height: 671px;
    margin-bottom: 50px;
    background-image: url(~@/assets/images/bg-rec.png);
}

.m-recommend ul {
    padding-top: 90px;
}

.m-recommend li {
    position: relative;
    width: 711px;
    height: 270px;
    margin: 0 auto 10px;
    background-image: url(~@/assets/images/bg-rec-item.png);
}

.m-recommend .banner {
    margin-bottom: 10px;
    font-size: 28px;
    color: #683d1e;
    font-weight: 700;
}

.m-recommend .pic {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 113px;
    height: 112px;
    background-image: url(~@/assets/images/bg-item_2.png);
}

.m-recommend .pic img {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 70px;
    height: 70px;
    transform: translate(-50%, -50%);
}

.m-recommend .discount {
    position: relative;
    margin-bottom: 16px;
    padding-left: 72px;
    color: #d33d27;
}

.m-recommend .discount::before {
    position: absolute;
    display: block;
    content: '';
    width: 64px;
    height: 38px;
    left: 0;
    top: -5px;
    background-image: url(~@/assets/images/icon-down.png);
    background-size: 64px auto;
}

.m-recommend .goods-detail {
    padding-top: 25px;
    padding-left: 115px;
}

.m-recommend .item-info {
    margin-left: 15px;
}

.m-recommend .item-name {
    margin: 12px 0;
    font-size: 24px;
    color: #683d1e;
    font-weight: 700;
}

/* .icon-m3b {
    display: inline-block;
    width: .26rem;
    height: .26rem;
    background-image: url(~@/assets/images/m3b.png);
    vertical-align: text-top;
    margin: 0 .1rem 0 .15rem;
} */

.m-recommend .low {
    color: #683d1e;
}

.m-recommend .p-before {
    padding-left: 8px;
    color: #ad7239;
    text-decoration: line-through;
}

.m-recommend .u-btn.apply {
    position: absolute;
    right: 40px;
    top: 120px;
    width: 100px;
    height: 100px;
    background-image: url(~@/assets/images/btn-apply_3.png);
}

.m-recommend .goods-status {
    position: absolute;
    left: 14px;
    top: 0;
    width: 100px;
    display: flex;
    justify-content: center;
}

.m-recommend .tag {
    margin-right: 8px;
}

.m-recommend .tag-sale {
    width: 41px;
    height: 168px;
    background-image: url(~@/assets/images/icon-sale_2.png);
}

.m-recommend .tag-shop {
    width: 41px;
    height: 188px;
    background-image: url(~@/assets/images/icon-ticket_2.png);
}

.shop-guide {
    padding-left: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/recommend.vue